module.exports = __webpack_public_path__ + "static/media/AoA_RaceGameEnvShot_09.b07eee6d.jpg";